// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".chat-manager-container{position:fixed;height:100%;bottom:0;right:0;z-index:999}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
